export const pagesHomeMixins = {
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    search: '',
    page: 1,
    itemsPerPage: 20,
    showSkeleton: true,
  }),

  async created() {
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
    }
  },

  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    firstPage() {
      if (this.page > 1) {
        this.page = 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    lastPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.numberOfPages
        this.$router.push({ query: { page: this.page } })
      }
    },
  },
}
